// Environment configuration file

// Determine current environment
const isDevelopment = process.env.NODE_ENV === 'development';
const isLocalhost =
  typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );

// 获取和格式化基础路径
function getBasePath() {
  // 从环境变量或默认值获取基础路径
  const rawPath = process.env.REACT_APP_BASE_PATH || '/track_order_page/';

  // 确保路径以斜杠开头
  let path = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;

  // 确保路径以斜杠结尾 - React Router 需要
  if (!path.endsWith('/')) {
    path = `${path}/`;
  }

  return path;
}

// API configuration
const API_CONFIG = {
  // Keep API requests on the canonical /toolsbackend path. CRA proxies this
  // path to the local shared backend; production hosts rewrite it upstream.
  API_URL: process.env.REACT_APP_API_URL || ''
};

// Shopline API configuration removed - now handled by backend API

// Export configuration
const config = {
  API_URL: API_CONFIG.API_URL,
  IS_DEVELOPMENT: isDevelopment,
  IS_LOCALHOST: isLocalhost,
  // 使用函数获取正确格式的基础路径
  BASE_PATH: getBasePath()
};

export default config;
